import type { Emitter } from 'nanoevents'
import { createNanoEvents } from 'nanoevents'
import { defineNuxtPlugin } from 'nuxt/app'

declare module 'nuxt/app' {
  interface NuxtApp {
    $eventBus: Emitter
  }
}

export default defineNuxtPlugin({
  name: 'eventbus-provider:plugin',
  setup() {
    const $eventBus = createNanoEvents()
    return {
      provide: {
        eventBus: $eventBus,
      },
    }
  },
})
